module.exports = __webpack_public_path__ + "img/coupon-with-code.6c0c88dc.png";